const AppImages = {
    //logo: "/images/logo.svg",
    logo: "/images/logo.png",
    icon: "/images/icon.png",
    favicon: "/images/favicon.png",
    slider1: "/images/slider1.jpg",
    slider2: "/images/slider2.jpg",
    slider3: "/images/slider3.jpg",
    default: "/images/default.jpg",
    meta: process.env.publicUrl+"/images/meta.jpg",
    loading: "/images/loading.gif",
    avatar: "/images/avatar.png", 
}

export default AppImages